import { LoadingBar } from 'view-design'
import router from './router'
import store from './store'
import createRoutes from '@/utils/createRoutes'
import { getDocumentTitle, resetTokenAndClearUser } from './utils'

// 是否有菜单数据
let hasMenus = false
router.beforeEach(async (to, from, next) => {
    document.title = '优服技术平台'
    LoadingBar.start()
    if (to.path === '/qrCode' || to.path === '/qrcode') {
        document.title = '邀约签到'
        next()
    } else {
        if (localStorage.getItem('token')) {
            if (to.path === '/login') {
                next({ path: '/' })
            } else if (hasMenus) {
                next()
            } else {
                try {
                    // 这里可以用 await 配合请求后台数据来生成路由
                    // const data = await axios.get('xxx')
                    // const routes = createRoutes(data)
                    const routes = createRoutes(JSON.parse(localStorage.getItem('menuItems')))
                    console.log("新的路由:", routes);
                    // 动态添加路由
                    router.addRoutes(routes)
                    hasMenus = true
                    console.log('to.path===', to.path);
                    next({ path: to.fullPath || '/' })
                } catch (error) {
                    console.log(error, "error");
                    resetTokenAndClearUser()
                    next(`/login?redirect=${to.path}`)
                }
            }
        } else {
            hasMenus = false
            if (to.path === '/login') {
                next()
            } else {
                next(`/login?redirect=${to.path}`)
            }
        }
    }

})

router.afterEach(() => {
    LoadingBar.finish()
})
